import React from 'react';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { SearchApp } from './app/SearchApp';

const mountEl = document.getElementById('property-search-root');
if (mountEl) {
  const root = ReactDOM.createRoot(mountEl);
  root.render(<StrictMode><SearchApp el={mountEl} /></StrictMode>);
}
